module.exports = __webpack_public_path__ + "img/cx2.a25b83b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/trait/cx2.png
// module id = v9II
// module chunks = 10